import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../../api/apiFactory";
import { showNotification } from "../notificationSlice";
const orderHistoryApi = factory.get("orderHistory");

const initialState = {
  history: {
    data: [],
    loading: false,
    total: 0,
    filters: {
      skip: 0,
      page: 0,
      take: 25,
      item_id: null,
      sn: "",
    },
  },
};

const orderHistorySlice = createSlice({
  name: "orderHistory",
  initialState,
  reducers: {
    setData: (state, { payload }) => {
      state.history.data = payload.data;
      state.history.total = payload.total;
    },
    setLoading: (state, { payload }) => {
      state[payload].loading = !state[payload].loading;
    },
    setFilters: (state, { payload }) => {
      state.history.filters = {
        ...state.history.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.history.filters = initialState.history.filters;
    },
  },
});

export const {
  setData,
  setLoading,
  setFilters,
  resetFilters,
} = orderHistorySlice.actions;

export default orderHistorySlice.reducer;

const index = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading("history"));
    const rawFilters = getState().orderHistory.history.filters;
    const filters = {
        ...rawFilters,
        item_id: rawFilters.item_id?.id || rawFilters.item_id,
    }
    const res = await orderHistoryApi.orderHistory(filters);
    dispatch(setData(res.data));
    dispatch(setLoading("history"));
  } catch (err) {
    dispatch(setLoading("history"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response?.data?.message || "حدث خطأ ما",
      }),
    );
    throw new Error(err);
  }
};

export const OrderHistoryAction = {
  index,
};
